export function confidenceLabel(score) {
  if (score >= 0.9) return { label: 'Fiable', tone: 'good' };
  if (score >= 0.72) return { label: 'À vérifier', tone: 'warn' };
  return { label: 'Incertain', tone: 'bad' };
}

export function documentConfidence(document) {
  const regions = document.pages.flatMap(page => page.regions).filter(region => region.text);
  if (!regions.length) return 0;
  return regions.reduce((sum, region) => sum + region.confidence, 0) / regions.length;
}
